import { render, staticRenderFns } from "./LegalDocumentsInternalPage.vue?vue&type=template&id=f0e010e4&scoped=true"
import script from "./LegalDocumentsInternalPage.vue?vue&type=script&lang=js"
export * from "./LegalDocumentsInternalPage.vue?vue&type=script&lang=js"
import style0 from "./LegalDocumentsInternalPage.vue?vue&type=style&index=0&id=f0e010e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e010e4",
  null
  
)

export default component.exports